// extracted by mini-css-extract-plugin
module.exports = {"table":"SearchResults__table___1t9G0"};